import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_xtvv45q74f: FaireBrandEntity = {
  token: "b_xtvv45q74f",
  type: "brand",
  name: "Meem's Fudge Shoppe",
  avatarUrl:
    "https://cdn.faire.com/fastly/4df1e3855d454c670d67e11b2df66545981f03bf3a96da651f26ed12ef0a1a8e.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/22a99a924ad7785a947a317f8a703b3c069b2f4e4b7a60036023419a59bcea0d.png",
  logoUrl:
    "https://cdn.faire.com/fastly/4df1e3855d454c670d67e11b2df66545981f03bf3a96da651f26ed12ef0a1a8e.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/22a99a924ad7785a947a317f8a703b3c069b2f4e4b7a60036023419a59bcea0d.png",
  location: "Tavares, FL, USA",
  minimumOrderDollars: 104,
  rating: 5,
  reviewCount: 9,
  isInsider: true,
  description:
    "Meem's Fudge Shoppe is where every bite tells a story of sweetness, nostalgia, and a touch of whimsy. At Meem's, we believe that fudge isn't just a treat; it's an experience that brings joy, comfort, and a sense of togetherness. \n\nOur journey began with a simple, heartfelt goal: to create the most delectable, melt-in-your-mouth fudge that not only satisfies your sweet tooth but also evokes cherished memories of simpler times. Whether it's the creamy texture that takes you back to your grandma's kitchen or the innovative flavors that excite your taste buds, we strive to make each piece a moment of pure delight.\n\nMeem's Fudge Shoppe is more than just a fudge shop; it's a labor of love. We carefully handcraft each batch using only the finest ingredients, ensuring that every batch is of the highest quality. From classic favorites like rich chocolate and buttery caramel to adventurous twists like dark chocolate sea salt and maple with bourbon brown sugar pecans or white chocolate raspberry, there's a flavor for every palate and occasion.\n\nWe're passionate about bringing a smile to your face, whether you're indulging yourself or sharing our fudge with someone special. Our shop is built on the values of warmth, community, and a genuine appreciation for life's sweet moments. We cherish our customers and believe that excellent customer service is as essential as our delicious fudge.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:53:05.602Z",
    importedBy: "entity-db-cli",
  },
};
